
/**
 * Creates a shouldForwardProp function based on the parameter
 * @param propNames An array containing the name of each prop that should be filtered out
 * @returns A shouldForwardProp function
 */
export function createShouldForwardProp(propNames: string[]): (prop: string) => boolean {
  return (prop) => !propNames.includes(prop);
}